import { alpha, Box, TableCell } from "@mui/material";
import { rankFormat } from "~/lib/number-k-formatting";

interface Props {
  id: number;
  isSmall?: boolean;
}

export function RankCell({ id, isSmall }: Props) {
  const rank = rankFormat(id);
  return (
    <TableCell sx={isSmall ? { pl: "5px !important" } : {}}>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          width: (theme) => theme.spacing(3),
          height: (theme) => theme.spacing(3),
          borderRadius: "50%",
          backgroundColor: (theme) =>
            alpha(theme.palette.background.light, 0.6),
          fontSize: 12,
          fontWeight: 700,
          textTransform: "lowercase",
        }}
      >
        {rank}
      </Box>
    </TableCell>
  );
}
